var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWineCups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "27px",
    viewBox: "0 0 26 27",
    style: {
      enableBackground: "new 0 0 26 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wine-cups"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,25H9v-5.185c1.162-0.413,1.999-1.512,1.999-2.816c0-1.304-0.837-2.402-1.999-2.815v-2.325c3.944-0.507,7-3.956,7-8.035 C16,2.48,15.665,1,15.081,0H0.919C0.335,1,0,2.516,0,3.859c0,4.079,3.056,7.497,7,8v2.324c-1.162,0.412-2.001,1.512-2.001,2.815 c0,1.305,0.839,2.403,2.001,2.816V25H3c-0.553,0-1,0.448-1,1s0.447,1,1,1h10c0.552,0,1-0.448,1-1S13.552,25,13,25z M2.117,5 C2.041,4.618,2,4.225,2,3.823C2,3.234,2.084,3,2.251,2h11.498C13.916,2,14,3.27,14,3.859c0,0.389-0.04,0.77-0.111,1.141H2.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,25h-4v-5.185c1.162-0.413,1.999-1.512,1.999-2.816c0-1.304-0.837-2.402-1.999-2.815v-2.325 c3.944-0.507,7-3.956,7-8.035C26,2.48,25.665,1,25.081,0h-8.896C16.691,1.084,17,2.459,17,3.823c0,2.739-1.22,5.226-3.16,6.906 c0.943,0.585,2.013,0.983,3.16,1.13v2.324c-1.163,0.412-2.001,1.512-2.001,2.815c0,1.305,0.838,2.403,2.001,2.816V25h-2.278 C14.894,25.295,15,25.635,15,26s-0.106,0.705-0.278,1H23c0.552,0,1-0.448,1-1S23.552,25,23,25z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineCups);
export default __webpack_public_path__ + "static/media/wine-cups.f79b9784a44ed5b0b9dd291eff4b417c.svg";
export { ForwardRef as ReactComponent };